import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { ReadTemplateDto } from '@goparrot/campaign-sdk';
import { CAMPAIGNS_QUERIES_ENUM } from '../enums';
import { campaignTemplateFacade } from '../facades/campaignTemplate';

export const useGetCampaignTemplates = (merchantId: string, options?: UseQueryOptions<ReadTemplateDto[]>): UseQueryResult<ReadTemplateDto[]> =>
  useQuery([CAMPAIGNS_QUERIES_ENUM.GET_TEMPLATES, merchantId], () => campaignTemplateFacade.getList(merchantId), options);
